import { useEffect, useMemo } from 'react';
// oxlint-disable-next-line no-restricted-imports
import { useRouteError } from 'react-router';
import type { RUMCustomErrorContext } from '@gonfalon/telemetry/types';

import { trackRouteError } from './trackRouteError';

type UseTrackRouteErrorArgs = RUMCustomErrorContext & {
  disableAutoTrack?: boolean;
};

/**
 * Wrapper around `useRouteError` hook that sends the error to Datadog.
 * @returns Route error object
 */
export function useTrackRouteError({
  disableAutoTrack,
  inflightExperiences,
  isCrash,
  metadata,
  owner,
  severity,
  url,
}: UseTrackRouteErrorArgs = {}) {
  const error = useRouteError();
  const trackError = useMemo(
    () => () => trackRouteError(error, { inflightExperiences, isCrash, metadata, owner, severity, url }),
    [error, inflightExperiences, isCrash, metadata, owner, severity, url],
  );

  useEffect(() => {
    if (!disableAutoTrack) {
      trackError();
    }
  }, [disableAutoTrack, trackError]);

  return {
    error,
    trackError,
  };
}
